import { createSlice } from '@reduxjs/toolkit'

export const serverStatusSlice = createSlice({
  name: 'serverStatus',
  initialState: {
    redirectType: null, // <-- Estado inicial: // 'network' | 'backend'
    maintenance: {
      active: false,
      config: null,
    },
  },
  reducers: {
    setRedirectError: (state, action) => {
      state.redirectType = action.payload
    },
    clearRedirectError: state => {
      state.redirectType = null
    },
    setMaintenanceMode: (state, action) => {
      state.redirectType = null
      state.maintenance.active = true
      state.maintenance.config = action.payload || null
    },
    clearMaintenanceMode: state => {
      state.maintenance.active = false
      state.maintenance.config = null
    },
  },
})

export const {
  setRedirectError,
  clearRedirectError,
  setMaintenanceMode,
  clearMaintenanceMode,
} = serverStatusSlice.actions
export default serverStatusSlice.reducer
